<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :setLoading="setLoading"
    :persistenceKey="'bin-list'"
    :defaultUserSettings="false"
    ref="bin-list-ref"
  >
    <template #popup>
      <GcPopupChangeLocation
        :popupConfig="changeLocationPopupConfig"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-change-location',
        }"
        :data-model="dataModel"
        :show-loading="ShowLoading"
        :width="450"
        :height="isBulkChange ? 180 : 280"
        :save-call-back="onLocationChangeCompleted"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="changeLocationPopupConfig.isPopupShow"
        :isBulkChange="isBulkChange"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
// gc-popup-change-location
import GcPopupChangeLocation from "../../../popups/gc-popup-change-location.vue";

import TransactionListTemplate from "../../../templates/transaction-list";
import {
  ReportTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/inventory/grid-reports";
import { FeatureStorage } from "../../../_services/storage";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import dataGridMixin from "../../../_mixins/data-grid.mixin";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, dataGridMixin],
  components: {
    TransactionListTemplate,
    GcPopupChangeLocation,
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,
      changeLocationPopupConfig: {
        title: "Update Bin Location",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
      },
      dataModel: {},
      isBulkChange: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Bin List",
        ScreenName: "Bin List",
        selectedIndex: GetIndexByTabName("Bin List"),
        tabs: ReportTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoBinList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              key: "BinCardNo",
              keyType: {
                InStorageLocationSiteRecordId: "Guid",
                InStorageLocationBuildingRecordId: "Guid",
                InStorageLocationAreaRecordId: "Guid",
                InStorageLocationSiteRecordIdMulti: "Guid",
                InStorageLocationBuildingRecordIdMulti: "Guid",
                InStorageLocationAreaRecordIdMulti: "Guid",
                InStorageLocationAisleRecordIdMulti: "Guid",
              },
              select: this.getSelectFields(this.getColumns),
            },
            options: {
              selectionMode: "multiple",
            },

            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No Bins Found",
                message:
                  "No bins were found for the selected filters. Please adjust your filters and try again.",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            filterOnEnter: true,

            customButtons: [
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 150 },
                  items: [
                    {
                      menuText: "Update Bin Location",
                    },
                  ],
                  onItemClick: () => {
                    this.updateBinLocation();
                  },
                },
              },
            ],
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          filterIndex: 1,
          screenField: "BinCardNo",
          gridDataField: "BinCardNo",
          dataField: "BinCardNo",
          width: ColumnWidth.TransactionNo,
          filterValueChangeEvent: "input",
        },
        {
          visible: true,
          filterIndex: 8,
          gridDataField: "ProductCode",
          screenField: "Product",
          editorOptions: {
            filter: ["Inactive", "=", "N"],
          },
          filterOverWrites: {
            select: [
              "Inactive",
              "ProductTypeCode",
              "Code",
              "Description1",
              "Status",
            ],
            filter: [
              [
                ["Inactive", "=", "N"],
                "and",
                ["Status", "=", "A"],
                "and",
                [
                  ["ProductTypeCode", "=", "BK"],
                  "or",
                  ["ProductTypeCode", "=", "WIP"],
                ],
              ],
            ],
          },
        },
        {
          screenField: "FiscalYearSelect",
          filterDataField: "SeasonYear",
          label: "Season Year",
          filterLabel: "Season Year",
          dataField: "SeasonYear",
          filterIndex: 2,
          sortOrder: "desc",
          sortIndex: 0,
          width: ColumnWidth.Date,
        },
        {
          screenField: "NetWeight",
        },
        {
          dataField: "BinCreateDate",
          filterDataField: "BinCreateDate",
          filterIndex: 9,
          screenField: "DateCreated",
          sortOrder: "desc",
          sortIndex: 1,
        },
        {
          filterIndex: 10,
          screenField: "DateFumigated",
        },

        // {
        //   sortIndex: 0,
        //   label: "Product Code and Description",
        //   screenField: "ProductConcat",
        // },
        {
          label: "FAQ %",
          dataField: "FAQPcnt",
          width: 75,
          screenField: "AllocatedPcnt",
        },
        {
          label: "Insect Damage %",
          dataField: "InsectDamagePcnt",
          width: 75,
          screenField: "AllocatedPcnt",
        },
        {
          label: "Mositure %",
          dataField: "MositurePcnt",
          width: 75,
          screenField: "AllocatedPcnt",
        },
        {
          label: "Grade",
          dataField: "Grade",
          width: 50,
          screenField: "ColumnValue",
        },
        {
          label: "Created In WO",
          dataField: "WorkOrder",
          width: 75,
        },
        {
          label: "Source",
          dataField: "Source",
          width: 75,
          screenField: "ColumnValue",
        },
        {
          visible: false,
          filterIndex: 3,
          screenField: "Branch",
        },
        {
          visible: false,
          width: 100,
          screenField: "LocationCode",
          gridDataField: "InStorageLocationCode",
          filterDataField: "InStorageLocationCode",
          cellTemplate: undefined,
          exportFields: undefined,
          filterIndex: 1,
          type: "Text",
          textOperators: true,
          filterOperator: "=",
        },
        {
          filterDataField: "InStorageLocationSiteRecordId",
          dataField: "InStorageLocationSite",
          width: 100,
          filterIndex: 4,
          screenField: "Site",
          multiSelect: false,
        },
        {
          filterDataField: "InStorageLocationBuildingRecordId",
          dataField: "InStorageLocationBuilding",
          width: 100,
          filterIndex: 5,
          screenField: "Building",
          multiSelect: false,
          dataSourceConfig: {
            endpoint: "api/BuildingList",
            sort: {
              selector: "Building",
              asc: true,
            },
            keyType: {
              BuildingRecordId: "Guid",
            },
            fieldType: {
              BuildingRecordId: "Guid",
            },
          },
          filterDependsOn: {
            parents: [
              {
                parentField: "InStorageLocationSiteRecordId",
                filterParam: "SiteRecordId",
                paramType: "Guid",
              },
            ],
          },
          editorTemplate: {
            primary: [
              {
                dataField: "Building",
              },
            ],
          },
          valueExpr: "BuildingRecordId",
          displayExpr: "Building",
          searchExpr: ["Building"],
        },
        {
          filterDataField: "InStorageLocationAreaRecordId",
          dataField: "InStorageLocationArea",
          width: 100,
          filterIndex: 6,
          screenField: "Area",
          multiSelect: false,
          dataSourceConfig: {
            endpoint: "api/AreaList",
            sort: {
              selector: "Area",
              asc: true,
            },
            keyType: {
              AreaRecordId: "Guid",
            },
            fieldType: {
              AreaRecordId: "Guid",
            },
          },
          filterDependsOn: {
            parents: [
              {
                parentField: "InStorageLocationBuildingRecordId",
                filterParam: "BuildingRecordId",
                paramType: "Guid",
              },
              {
                parentField: "InStorageLocationSiteRecordId",
                filterParam: "SiteRecordId",
                paramType: "Guid",
              },
            ],
          },
          editorTemplate: {
            primary: [
              {
                dataField: "Area",
              },
            ],
          },
          valueExpr: "AreaRecordId",
          displayExpr: "Area",
          searchExpr: ["Area"],
        },
        {
          width: 100,
          filterIndex: 7,
          screenField: "AisleINT",
          filterValueChangeEvent: "input",
          multiSelect: false,
          dataSourceConfig: {
            endpoint: "api/AisleList",
            sort: {
              selector: "Aisle",
              asc: true,
            },
          },
          filterDependsOn: {
            parents: [
              {
                parentField: "InStorageLocationAreaRecordId",
                filterParam: "AreaRecordId",
                paramType: "Guid",
              },
              {
                parentField: "InStorageLocationBuildingRecordId",
                filterParam: "BuildingRecordId",
                paramType: "Guid",
              },
              {
                parentField: "InStorageLocationSiteRecordId",
                filterParam: "SiteRecordId",
                paramType: "Guid",
              },
            ],
          },
          editorTemplate: {
            primary: [
              {
                dataField: "Aisle",
              },
            ],
          },
          valueExpr: "Aisle",
          displayExpr: "Aisle",
          searchExpr: ["Aisle"],
        },
        {
          visible: false,
          filterLabel: "Category 1",
          // gridDataField: "ProductCategory1DescriptionAndCode",
          screenField: "ProductCategory1",
        },
        {
          visible: false,
          filterLabel: "Category 2",
          // gridDataField: "ProductCategory2DescriptionAndCode",
          screenField: "ProductCategory2",
        },
        {
          visible: false,
          filterLabel: "Category 3",
          // gridDataField: "ProductCategory3DescriptionAndCode",
          screenField: "ProductCategory3",
        },
        {
          visible: false,
          filterLabel: "Category 4",
          // gridDataField: "ProductCategory4DescriptionAndCode",
          screenField: "ProductCategory4",
        },
        {
          visible: false,
          filterLabel: "Type",
          // gridDataField: "ProductTypeDescriptionAndCode",
          screenField: "ProductType",
        },
        {
          visible: false,
          screenField: "Attribute01Description",
        },
        {
          visible: false,
          screenField: "Attribute02Description",
        },
        {
          visible: false,
          screenField: "Attribute03Description",
        },
        {
          visible: false,
          screenField: "Attribute04Description",
        },
        {
          visible: false,
          screenField: "Attribute06Description",
        },
        {
          visible: false,
          screenField: "Attribute07Description",
        },
        {
          visible: false,
          screenField: "Attribute08Description",
        },
        {
          visible: false,
          screenField: "Attribute09Description",
        },
        {
          visible: false,
          screenField: "Attribute10Description",
        },
        {
          visible: false,
          screenField: "Attribute11Description",
        },
        {
          visible: false,
          screenField: "Attribute12Description",
        },
        {
          visible: false,
          screenField: "Attribute13Description",
        },
        {
          visible: false,
          screenField: "Attribute14Description",
        },
        {
          visible: false,
          screenField: "Attribute15Description",
        },
        {
          visible: false,
          screenField: "Attribute16Description",
        },
        {
          visible: false,
          screenField: "Attribute17Description",
        },
        {
          visible: false,
          screenField: "Attribute18Description",
        },
        {
          visible: false,
          screenField: "Attribute19Description",
        },
        {
          visible: false,
          screenField: "Attribute20Description",
        },
        {
          screenField: "GridRecordEllipsisMenu",
          cssClass: "padding-7",
          allowSearch: false,
          select: false,
          ellipsisMenu: {
            itemAction: (data) => {
              return [
                {
                  menuText: "Change Location",
                  data: data,
                  clickAction: this.changeLocation,
                  disabled: FeatureStorage.checkPermission("BinList", "create")
                    ? false
                    : true,
                },
              ];
            },
            keyExpr: "menuText",
            displayExpr: "menuText",
          },
        },
        // Hidden fields for filters
        {
          filterDataField: "InStorageLocationSiteRecordIdMulti",
          dataField: "InStorageLocationSiteRecordIdMulti",
          width: 100,
          filterIndex: 11,
          screenField: "Site",
          visible: false,
          showInColumnChooser: false,
        },
        {
          filterDataField: "InStorageLocationBuildingRecordIdMulti",
          dataField: "InStorageLocationBuildingRecordIdMulti",
          width: 100,
          filterIndex: 12,
          screenField: "Building",
          visible: false,
          showInColumnChooser: false,
        },
        {
          filterDataField: "InStorageLocationAreaRecordIdMulti",
          dataField: "InStorageLocationAreaRecordIdMulti",
          width: 100,
          filterIndex: 13,
          screenField: "Area",
          visible: false,
          showInColumnChooser: false,
        },
        {
          filterDataField: "InStorageLocationAisleRecordIdMulti",
          dataField: "InStorageLocationAisleRecordIdMulti",
          width: 100,
          filterIndex: 14,
          screenField: "Aisle",
          visible: false,
          showInColumnChooser: false,
        },
      ];
    },
  },
  methods: {
    ShowLoading(value) {
      this.setLoading = value;
    },
    changeLocation(e) {
      this.isBulkChange = false;
      this.dataModel = e;

      this.changeLocationPopupConfig = {
        isPopupShow: true,
        hidden: () => {
          this.changeLocationPopupConfig.isPopupShow = false;
          this.isBulkChange = false;
        },
      };
    },
    onPopupHide() {
      this.changeLocationPopupConfig.isPopupShow = false;
    },

    onLocationChangeCompleted() {
      this.onPopupHide();
      this.showLoading(true);
      this.$refs["bin-list-ref"].$refs["transactionListGrid"].gridRefresh();
    },
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },

    updateBinLocation() {
      var selectedData =
        this.$refs["bin-list-ref"].$refs[
          "transactionListGrid"
        ].getSelectedRowsData();

      if (selectedData.length === 0) {
        this.$alert(
          "Please select at least one record to change the location.",
          "No Record Selected",
          { type: "warning" },
        );
        return;
      } else {
        this.isBulkChange = true;
        this.dataModel = selectedData;
        this.changeLocationPopupConfig = {
          isPopupShow: true,
          hidden: () => {
            this.changeLocationPopupConfig.isPopupShow = false;
            this.isBulkChange = false;
          },
        };
      }
    },
  },

  created() {
    this.setLoading = true;
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
